const environment = "Prod"; export default environment;
